import { render, staticRenderFns } from "./jss_calculator.vue?vue&type=template&id=a8066938&scoped=true&"
import script from "./jss_calculator.vue?vue&type=script&lang=js&"
export * from "./jss_calculator.vue?vue&type=script&lang=js&"
import style0 from "./jss_calculator.vue?vue&type=style&index=0&id=a8066938&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8066938",
  null
  
)

export default component.exports